module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/male-5-037b374691923fd6249e935b30da61c0.jpg";